import './index.scss';
import React, { Fragment } from 'react';
import { lang } from '@umu/ukit-lang';
import { Iconfont, Button } from '@umu/umu-design';
import { ListBlankPC } from 'businessCommon/src/components';
import { UMUBg } from 'common/src/components';
import { EmptyPracticeCard } from './components/emptyPracticeChannelCard';
import PracticeVideoIcon from './images/icon/practiceVideoIcon';
import { IPracticeChannle, PRACTICE_TYPE, IVideoCoverItem, IChatbotCoverItem } from '@umu/umu-types';
import chatbotScoreBg from './images/icon/chatbot-score-bg-0.png';

interface IProps {
    isMobile?: boolean;
    prefixCls: string;
    info: IPracticeChannle;
    onClick?: (item: IPracticeChannle) => void;
}

const PracticeCard = (props: IProps) => {
    const { isMobile = false, info, prefixCls, onClick } = props;
    const { name = '', practice_num = 0, practice_infos = [] } = info;

    const renderChatbotPreview = (item: IChatbotCoverItem) => {
        const score = item.chatbot_info.score;
        const fontSize = score > 9 ? 'font-size-19' : 'font-size-22';
        return (
            <div
                key={`preview-chatbot-${item.practice_id}`}
                className="w-100% h-100% border-radius-4 bg-color-002D90 m-r-10 position-relative preview-chatbot"
            >
                <div className="cover-img"></div>
                <div className="flex-center position-absolute l-0 r-0 t-0 b-0">
                    <div
                        className="w-24 h-24 border-radius-24 m-r-10"
                        style={{
                            background: `url(${item.chatbot_info.user_info.avatar}) #fff no-repeat center / cover`,
                        }}
                    />
                    <div
                        className={`weight-700 w-36% h-76% flex-center rank ${fontSize}`}
                        style={{
                            background: `url(${chatbotScoreBg}) no-repeat center / cover`,
                        }}
                    >
                        <span>{score}</span>
                    </div>
                </div>
            </div>
        );
    };

    const renderPreviewList = () => {
        const total = practice_infos.length || 0;

        const isEmpty = total === 0;
        if (isEmpty) {
            return (
                <Fragment>
                    <ListBlankPC className="preview-empty mobile-hide" type={2} />
                    <div className="practice-empty-text mobile-hide">{lang('暂无提交视频')}</div>
                </Fragment>
            );
        }

        return practice_infos.map((item, index) => {
            let info = <></>;
            if (item.obj_type == PRACTICE_TYPE.HOMEWORK_VIDEO) {
                const video = item as IVideoCoverItem;
                info = <UMUBg clsName="cover-img" bgSrc={video.video_info.cover_img_url} />;
            }
            if (item.obj_type == PRACTICE_TYPE.CHATBOT) {
                const chatbot = item as IChatbotCoverItem;
                info = renderChatbotPreview(chatbot);
            }
            return (
                <div
                    key={`preview-${index}`}
                    className={`${prefixCls}-content-img-info img-count-${total} practice-card-content-img-info`}
                >
                    {info}
                </div>
            );
        });
    };

    const onJumpPractice = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
        e.stopPropagation();
        onClick?.(info);
    };

    return (
        <div className={`${prefixCls} practice-card ${isMobile ? 'is-mobile' : ''}`} onClick={onJumpPractice}>
            <div className={`${prefixCls}-title practice-card-title line-rows-2`}>{name}</div>
            {practice_num > 0 && (
                <div className={`${prefixCls}-content practice-card-content`}>
                    <div className="video-info mobile-hide">
                        <div className="practice-video-icon">
                            <PracticeVideoIcon />
                        </div>
                        <div>{lang('{$0{0= 个视频,1= 个视频}}', practice_num)}</div>
                    </div>
                    <div className={`${prefixCls}-content-img practice-card-content-img`}>{renderPreviewList()}</div>
                </div>
            )}
            <div className={`${prefixCls}-footer practice-card-footer pc-hide`}>
                <div className="video-info">
                    <div>{lang('{$0{0= 个练习记录,1= 个练习记录}}', practice_num)}</div>
                </div>
                <Button type="text" className="card-text-btn" onClick={onJumpPractice}>
                    {lang('进入频道')}
                    <Iconfont type={'ArrowRightOutlined'} className="right-icon" />
                </Button>
            </div>
        </div>
    );
};

export { PracticeCard, EmptyPracticeCard };
